module.exports = __webpack_public_path__ + "static/img/17.5d86ac7a.png";